import React, { PureComponent } from 'react';
import 'perfect-scrollbar/css/perfect-scrollbar.css';
import 'css/ViewHorizontalNavigation.scss';
import classNames from 'classnames';
import {
    ANOTHER_SPORTS_ID,
    APP_PATH,
    COUNTRIES_IMG,
    DANMARK_ID,
    LIVE_CASINO,
    ANBEFALET,
    ANBEFALET_SPORT_ID,
    LIVE_ID,
    REST_EUROPE_ID,
    REST_WORLD_ID,
    SOON_ID,
    BIG_NINE,
    SPORTS,
} from 'constants/appConfig';
import renderHTML from 'react-render-html';
import moment from 'moment';
import { browserHistory } from 'react-router';
import { desktopOnly } from 'utils/UiHelper';
import { goToWithBasePath } from '../constants/appConfig';

export default class ViewHorizontalNavigation extends PureComponent {
    static defaultProps = {
        clickHandler: () => {},
    };

    onClickHandler(item) {
        if (
            item.id !== LIVE_ID &&
            item.id !== SOON_ID &&
            item.id !== LIVE_CASINO &&
            item.id !== BIG_NINE
        ) {
            if (this.props.clickHandler) {
                this.props.clickHandler(item);
            }
        } else {
            let path = '/';

            switch (item.id) {
                case LIVE_ID:
                    path = goToWithBasePath('/live');
                    break;
                case SOON_ID:
                    path = goToWithBasePath('/pre');
                    break;
                case LIVE_CASINO:
                    path = goToWithBasePath('/live-casino');
                    break;
                case BIG_NINE:
                    path = goToWithBasePath('/big9');
                    break;
                default:
                    path = goToWithBasePath('/');
            }

            browserHistory.push(path);
        }
        if (
            this.props.trackClickEvent &&
            window.location.pathname.includes('/live') &&
            this.props.sortedSportsIds?.includes(item.id)
        ) {
            const index = this.props.items.findIndex((el) => el.id === item.id);
            const position = index + 1;
            this.props.trackClickEvent(
                'clicks:sport',
                `sr:sport:${item.id}`,
                'sport_id',
                'sr:widget:livepagesport:recommended',
                window.location.pathname,
                this.props.userId || 0,
                position
            );
        }
    }

    getCountryIcon(data) {
        let countryName = data.name
            .toLowerCase()
            .replace(' ', '.')
            .replace('- ', '');
        if (data.id === REST_EUROPE_ID || data.id === REST_WORLD_ID) {
            countryName = data.id;
        }

        if (data.id === DANMARK_ID) {
            countryName = 'danmark';
        }

        if (
            COUNTRIES_IMG.indexOf(countryName.toLowerCase()) > -1 ||
            countryName.toLowerCase() === 'brasilien'
        ) {
            return (
                <img
                    src={
                        APP_PATH +
                        '/img/sports/' +
                        countryName.toLowerCase() +
                        '.png'
                    }
                    className="country-flag"
                    width="20"
                    height="20"
                    alt={countryName}
                />
            );
        } else {
            return null;
        }
    }

    getIconSize(item) {
        return 30;
    }

    getIconName(item) {
        if (
            [
                SOON_ID,
                LIVE_CASINO,
                ANBEFALET,
                BIG_NINE,
                ANOTHER_SPORTS_ID,
                SPORTS.LEAGUE_OF_LEGENDS,
            ].includes(item.id)
        ) {
            return item.name;
        }
        if (item.id === LIVE_ID) {
            return <span className="red bold">{item.name}</span>;
        }
        if (item.id === SPORTS.SPECIALS) {
            return 'Specials';
        }
        if (item.name.includes('Resten ')) {
            return renderHTML(item.name);
        }
        return renderHTML(item.name.replace(' ', '<br />'));
    }

    getIconPath(item) {
        if (this.props.selectedSport) {
            return (
                APP_PATH + '/img/sports/' + this.props.selectedSport.id + '.png'
            );
        } else {
            if (item.id === ANBEFALET_SPORT_ID) {
                return APP_PATH + '/img/sports/' + 'for-dig' + '.png';
            } else {
                return APP_PATH + '/img/sports/' + item.id + '.png';
            }
        }
    }

    render() {
        const items = [];

        let filteredItems =
            this.props.selectedSport && this.props.selectedSport.itemList
                ? this.props.selectedSport.itemList
                : this.props.items
                    ? this.props.items
                    : [];

        items.push(...filteredItems);

        const liElements = items.map((item, index) => {
            return (
                <li
                    className={classNames({
                        active:
                            this.props.selectedId !== 'none' &&
                            this.props.selectedId === item.id.toString(),
                        live: item.id === LIVE_ID,
                    })}
                    key={index}
                    onClick={this.onClickHandler.bind(this, item)}
                >
                    <div className="sport-icon">
                        <img
                            src={this.getIconPath(item)}
                            width={this.getIconSize(item)}
                            height={this.getIconSize(item)}
                            alt={item.name}
                            className="fallback-svg"
                            onError={(e) => {
                                e.target.onerror = null;
                                e.target.src =
                                    APP_PATH + '/img/bet25sport_icon.svg';
                                e.target
                                    .closest('.sport-icon')
                                    .classList.add('sport-icon-error');
                            }}
                        />
                        {this.props.selectedSport &&
                        ((item.id > 0 &&
                            [
                                LIVE_CASINO,
                                ANBEFALET,
                                BIG_NINE,
                                LIVE_ID,
                                SOON_ID,
                            ].indexOf(item.id) === -1) ||
                            [DANMARK_ID, REST_EUROPE_ID, REST_WORLD_ID].indexOf(
                                item.id
                            ) > -1)
                            ? this.getCountryIcon(item)
                            : ''}
                    </div>

                    {item.id !== SOON_ID ? null : (
                        <div className="date-icon">{moment().format('DD')}</div>
                    )}

                    <div
                        className={
                            classNames({
                                f9:
                                    item.name.includes(' ') &&
                                    ![
                                        SOON_ID,
                                        LIVE_CASINO,
                                        BIG_NINE,
                                        ANBEFALET,
                                        ANOTHER_SPORTS_ID,
                                    ].includes(item.id),
                            }) + ' sign'
                        }
                    >
                        {this.getIconName(item)}
                    </div>
                </li>
            );
        });

        const backButton = this.props.showBackBtn ? (
            <div
                className="view-search-box-back-btn"
                onClick={() => {
                    this.props.backBtnHandler();
                }}
            >
                <i className="fa fa-angle-left fa-3x" aria-hidden="true" />
            </div>
        ) : null;
        return (
            <nav
                id="HorizontalNavigation"
                className={classNames(
                    'view-horizontal-navigation always-visible',
                    {
                        desktop: desktopOnly(),
                        backBtn: this.props.showBackBtn,
                    }
                )}
            >
                {backButton}

                <div className="scroll-area">
                    <ul
                        className={classNames({
                            'show-active-item':
                                this.props.selectedId !== undefined &&
                                this.props.selectedId !== 'none',
                        })}
                    >
                        {liElements}
                    </ul>
                </div>
            </nav>
        );
    }
}
